import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, ViewStyle} from 'react-native';

export default (props: ITheme) =>
  StyleSheet.create({
    container: {
      width: 46,
      height: 46,
      backgroundColor: props.colors.purple(0.13),
      borderRadius: 8,
      justifyContent: 'center',
      alignItems: 'center',
    },
    image: {
      width: 19.5,
      height: 19.5,
      resizeMode:'contain'
    },
    fullImage: {
      width: 46,
      height: 46,
      borderRadius: 8,
    },
  });
